var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1507.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Gift",
    transform: "translate(1206.000000, 1507.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,32 L29,32 L29,18 L18,18 L18,32 Z M27,8 L18,8 L18,16 L31,16 L31,12 C31,9.791 29.209,8 27,8 L27,8 Z M14,8 L5,8 C2.791,8 1,9.791 1,12 L1,16 L14,16 L14,8 Z M14,18 L3,18 L3,27.986 C3,30.203 4.791,32 7,32 L14,32 L14,18 Z M12,0 C13.657,0 15,1.343 15,3 L15,6 L12,6 C10.343,6 9,4.657 9,3 L9,0 L12,0 Z M23,3 C23,4.657 21.657,6 20,6 L17,6 L17,3 C17,1.343 18.343,0 20,0 L23,0 L23,3 Z",
    id: 209
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonGift);
export default __webpack_public_path__ + "static/media/common-gift.e3443ced.svg";
export { ForwardRef as ReactComponent };